export type LoggerConfig = {
  enabled: boolean;
  whitelist?: string[];   // names allowed in production
  prodWhitelist?: string[];   // names allowed in production
  env: 'development' | 'production';
};

export class Logger {
  private static config: LoggerConfig = {
    enabled: true,
    whitelist: [],
    prodWhitelist: [],
    env: 'development',
  };

  constructor(private name: string) {}

  static configure(config: Partial<LoggerConfig>) {
    Logger.config = { ...Logger.config, ...config };
  }

  log(...args: any[]) {
    if (!Logger.config.enabled) return;

    const { env, whitelist, prodWhitelist } = Logger.config;

    // In production → only allow prodWhitelist names
    // In dev → only allow whitelist names
    if ((env === 'production' && prodWhitelist && !prodWhitelist.includes(this.name)
    || env !== 'production' && whitelist && !whitelist.includes(this.name))) {
      return;
    }

    // Otherwise log with name prefix
    console.log(`%c[${this.name}]`, 'color: #ff8800; font-weight: bold;', ...args);
  }

  warn(...args: any[]) {
    if (!Logger.config.enabled) return;
    console.warn(`[${this.name}]`, ...args);
  }

  error(...args: any[]) {
    if (!Logger.config.enabled) return;
    console.error(`[${this.name}]`, ...args);
  }
}
